// Cosmic-themed random handle generator. All lowercase so it passes
// normalizeHandle. Word + 2-4 digit number, <= 16 chars total.

const WORDS = [
  "nova",
  "pulsar",
  "orbit",
  "comet",
  "meteor",
  "nebula",
  "quasar",
  "solar",
  "lunar",
  "star",
  "cosmo",
  "galaxy",
  "photon",
  "ion",
  "plasma",
  "void",
  "rift",
  "ember",
  "cinder",
  "rocket",
  "apollo",
  "helios",
  "titan",
  "zenith",
  "vega",
  "atlas",
  "argo",
  "sirius",
  "drake",
  "echo",
  "drift",
  "probe",
  "lander",
  "rover",
  "corona",
  "eclipse",
  "aurora",
  "halo",
  "flare",
  "zen",
  "drift",
  "nebly",
  "spark",
  "void",
  "axion",
  "proton",
  "boson",
  "quark",
  "tachyon",
  "warp",
  "hyper",
  "kepler",
  "jovian",
  "venusian",
  "martian",
  "stellar",
  "astro",
  "zero_g",
  "black_hole",
  "red_giant",
  "white_dwarf",
];

export function randomHandle(): string {
  const w = WORDS[Math.floor(Math.random() * WORDS.length)]!;
  // 2-4 digit number; weight toward 3-4 for uniqueness.
  const digits = Math.random() < 0.25 ? 2 : Math.random() < 0.5 ? 3 : 4;
  const maxN = Math.pow(10, digits);
  const n = Math.floor(Math.random() * maxN);
  const candidate = `${w}${String(n).padStart(digits, "0")}`;
  // Clamp to 16 chars.
  return candidate.slice(0, 16);
}
